import React from 'react';

import { Cards, CountryPicker, Chart } from './components';
import { fetchData } from './api/';
import styles from './App.module.css';

import logoImg from './img/ico.png';

class App extends React.Component {
  state = {
    data: {},
    country: '',
  }

  async componentDidMount() {
    const data = await fetchData();

    this.setState({ data });
  }

  handleCountryChange = async (country) => {
    const data = await fetchData(country);

    this.setState({ data, country: country });
  }

  render() {
    const { data, country } = this.state;

    return (
      <div className={styles.container}>

        <nav>
          <img className={styles.logo} src={logoImg} alt="Logo"/>
          <div className={styles.menu}>
            <div className={styles.infoAPI}>
              <h3>API developed by:</h3>
              <a href="https://github.com/mathdroid/covid-19-api" target="blank">mathdroid</a>
            </div>
          </div>
        </nav>

        <section className={styles.page}>
          <div className={styles.details}>
            <h1>Corona-Tracker</h1>
            <h2>Track & Visualization</h2>
          </div>
        </section>

        <Cards data={data} />
        <br/>
        <br/>
        <CountryPicker handleCountryChange={this.handleCountryChange} />
        <Chart data={data} country={country} />

        <footer>
          <div className={styles.developer}>
            <p>Copyright © 2020 All Rights Reserved by <a href="https://github.com/SebastianMM-96" target="blank">Sebastian Marroquín</a></p>
          </div>
        </footer>

      </div>
    );
  }
}

export default App;
